import { API_HOST } from "./config"
export default {
  OPEN_USER_TEST_DATA: `${API_HOST}front/test/get_open_tests`,
  OPEN_TEST_DATA: `${API_HOST}front/test/test_types`,
  OPEN_TEST_SCOREWISE: `${API_HOST}front/test/get_scorewise_result`,
  DELETE_OPEN_TEST:`${API_HOST}/front/test/delete_open_test`
}